import { getShareApiDateFormat } from "./common-methods.jsx";
import { VERTICALS, SOCIAL_SOURCES } from "../constants/app-constant";
const { FACEBOOK, INSTAGRAM, TWITTER, YOUTUBE, LINKEDIN } = SOCIAL_SOURCES;
const { V_BLOG, V_FORUM, V_SOCIAL } = VERTICALS;

export const formatSocialShareArticle = (article) => {
  const {
    created_at,
    permalink,
    from_username,
    title,
    message,
    channel_type,
    page_details,
    name,
    type,
    entityId,
    topic_name,
  } = article;
  let commonData = {
    publish_date: getShareApiDateFormat(created_at),
    entity_id: entityId,
    entity_name: topic_name,
    from_username: from_username || name || (page_details && page_details.name),
    permalink,
    message,
    title,
    platform: getSocialShareMediaType(channel_type, type),
  };
  return commonData;
};

export const formatSocialShareArticles = (articles = []) => {
  return articles.map((a) => {
    return formatSocialShareArticle(a);
  });
};

export const getSocialShareMediaType = (channel_type, type = V_SOCIAL) => {
  if (channel_type == V_BLOG) {
    return "blog";
  }
  if (channel_type == V_FORUM) {
    return "fourm";
  }
  if (type == V_SOCIAL) {
    const mType = {
      [FACEBOOK]: "facebook",
      [INSTAGRAM]: "instagram",
      [TWITTER]: "twitter",
      [YOUTUBE]: "youtube",
      [LINKEDIN]: "linkedin",
      // [PINTEREST]: "pinterest",
    };
    return mType[channel_type];
  }
};
